module.exports = __webpack_public_path__ + "img/Construction.1df28172.svg";